// Earning.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { createMRTColumnHelper } from "material-react-table";
import Chip from "@mui/material/Chip";
import { baseUrl } from "../../../helper/urls.js";
import CustomTable from "../../../components/custom_table/CustomTable.jsx";
import { useSelector } from "react-redux";
const Earning = () => {
  const { token } = useSelector((state) => state.auth);
  const [counselors, setCounselors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPaymentList = async () => {
    try {
      // console.log("akkkkkkkkkkkkkkkkkkk", counselor);
      const response = await axios.get(
        `${baseUrl}/bookings/counselor/getPaymentList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data.data || [];
      console.log(data, "dataaaaaaaaaaaa");

      // Add formattedReqId here
      const processedData = data.map((item) => ({
        ...item,
        formattedReqId: `DDR000${item.reqId || ""}`,
        studentName: `${item.s_firstName || ""} ${
          item.s_lastName || ""
        }`.trim(),
      }));

      setCounselors(processedData);
      setLoading(false);
    } catch (error) {
      setError("error bookingwihtaaaaaaaaaaaa", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentList();
  }, []);

  const statusMap = {
    0: "Un-Paid",
    1: "Paid",
  };
  const statusMapType = {
    0: "error",
    1: "success",
  };
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("status", {
      header: "Status",

      Cell: (cell) => {
        const status = cell.row.original.payout_status;
        return (
          (
            <Chip
              label={statusMap[status]}
              color={statusMapType[status]}
              variant="outlined"
            />
          ) || <Chip label="Pending" color="default" variant="outlined" />
        );
      },
    }),

    columnHelper.accessor("studentName", {
      header: "Student Name",
      size: 30,
    }),
    columnHelper.accessor("booking_date", {
      header: "Booking Date",
      size: 30,
      Cell: (cell) => cell.row.original?.booking_date?.split("T")[0] || "N/A",
    }),
    columnHelper.accessor("amount", {
      header: "Amount",
      size: 40,
      Cell: (cell) => cell.row.original?.amount,
    }),

    columnHelper.accessor("summary", {
      header: "Summary",
      size: 30,
      Cell: (cell) => cell.row.original?.summary || "--",
    }),
    columnHelper.accessor("formattedReqId", { header: "Request ID" }),
  ];

  return <CustomTable columns={columns} data={counselors} loading={loading} />;
};

export default Earning;
